import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Chip,
  Avatar,
  Stack,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { API_BASE_URL } from '../../../utils/BaseUrl';

const ORANGE = '#FF9800';
const ORANGE_LIGHT = '#FFE0B2';
const ORANGE_GRADIENT = 'linear-gradient(135deg, #FFE0B2 0%, #FFF3E0 100%)';

const getStatusIcon = (PaymentStatus) => {
  if (PaymentStatus === 'Pending' || PaymentStatus === 'Paid') {
    return <CheckCircleIcon sx={{ color: '#fff' }} />;
  }
  return <HourglassEmptyIcon sx={{ color: '#fff' }} />;
};

const PackageOwnerList = () => {
  const [packageOwners, setPackageOwners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Lấy userId từ localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;
  const userFullName = user?.fullName;

  useEffect(() => {
    const fetchPackageOwners = async () => {
      if (!userId) return;

      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/PackageOwner/GetPackageOwnersByUserId?userId=${userId}`
        );
        setPackageOwners(response.data);
      } catch (error) {
        console.error("Error fetching package owners", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackageOwners();
  }, [userId]);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress sx={{ color: ORANGE }} />
      </Box>
    );

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Typography variant="h5" gutterBottom fontWeight={700} sx={{ color: ORANGE, mb: 3 }}>
        Gói đã mua của: {userFullName}
      </Typography>
      <Grid container spacing={2}>
        {packageOwners.map(po => (
          <Grid item xs={12} sm={6} md={4} key={po.packageOwnerId}>
            <Card
              sx={{
                background: ORANGE_GRADIENT,
                color: '#6d4c1b',
                borderRadius: 2,
                boxShadow: 3,
                p: 1.5,
                minHeight: 180,
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.18s, box-shadow 0.18s',
                '&:hover': {
                  transform: 'scale(1.025)',
                  boxShadow: 8,
                  background: 'linear-gradient(135deg, #FFD180 30%, #FFF3E0 100%)',
                },
              }}
            >
              <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Stack direction="row" alignItems="center" spacing={1.2} mb={1.2}>
                  <Avatar sx={{ bgcolor: ORANGE_LIGHT, color: ORANGE, width: 32, height: 32 }}>
                    {getStatusIcon(po.paymentStatus)}
                  </Avatar>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: ORANGE, fontSize: 16 }}>
                    {po.packageName}
                  </Typography>
                </Stack>
                <Typography variant="body2" sx={{ mb: 0.5, fontSize: 13 }}>
                  <b>Mã đơn:</b> {po.orderCode}
                </Typography>
                <Chip
                  label={po.paymentStatus}
                  sx={{
                    background:
                      po.paymentStatus === 'Pending'
                        ? '#ffcdd2'
                        : po.paymentStatus === 'Paid'
                          ? '#C8E6C9'
                          : ORANGE_LIGHT,
                    color:
                      po.paymentStatus === 'Pending'
                        ? '#d32f2f'
                        : po.paymentStatus === 'Paid'
                          ? '#388e3c'
                          : ORANGE,
                    fontWeight: 600,
                    mb: 1,
                    fontSize: 12,
                    height: 22,
                  }}
                  size="small"
                />
                <Stack direction="row" alignItems="center" spacing={0.7} sx={{ mb: 0.5 }}>
                  <CalendarMonthIcon fontSize="small" sx={{ fontSize: 16 }} />
                  <Typography variant="body2" sx={{ fontSize: 13 }}>
                    <b>Bắt đầu:</b> {po.startDate}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.7} sx={{ mb: 0.5 }}>
                  <CalendarMonthIcon fontSize="small" sx={{ fontSize: 16 }} />
                  <Typography variant="body2" sx={{ fontSize: 13 }}>
                    <b>Kết thúc:</b> {po.endDate}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.7} sx={{ mb: 0.5 }}>
                  <CalendarMonthIcon fontSize="small" sx={{ fontSize: 16 }} />
                  <Typography variant="body2" sx={{ fontSize: 13 }}>
                    <b>Ngày tạo:</b> {new Date(po.createdAt).toLocaleString()}
                  </Typography>
                </Stack>

              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PackageOwnerList;
